var _defs, _desc, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDownload(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "SVGDoc",
    width: 26,
    height: 32,
    viewBox: "0 0 26 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Generated with Avocode.")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("title", null, "Linie 195"), /*#__PURE__*/React.createElement("path", {
    d: "M24.99966,30.56934h-23.569",
    fillOpacity: 0,
    fill: "#ffffff",
    strokeDashoffset: 0,
    strokeLinejoin: "round",
    strokeLinecap: "round",
    strokeOpacity: 1,
    stroke: "#96142d",
    strokeMiterlimit: 20,
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("title", null, "Linie 196"), /*#__PURE__*/React.createElement("path", {
    d: "M13.21582,1v23.569",
    fillOpacity: 0,
    fill: "#ffffff",
    strokeDashoffset: 0,
    strokeLinejoin: "round",
    strokeLinecap: "round",
    strokeOpacity: 1,
    stroke: "#96142d",
    strokeMiterlimit: 20,
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("title", null, "Pfad 4497"), /*#__PURE__*/React.createElement("path", {
    d: "M20.07456,17.7191v0l-6.85,6.85v0l-6.598,-6.598v0",
    fillOpacity: 0,
    fill: "#ffffff",
    strokeDashoffset: 0,
    strokeLinejoin: "round",
    strokeLinecap: "round",
    strokeOpacity: 1,
    stroke: "#96142d",
    strokeMiterlimit: 20,
    strokeWidth: 2
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownload);
export default __webpack_public_path__ + "static/media/download.1d421fb5.svg";
export { ForwardRef as ReactComponent };